import React from 'react';
import Icon from 'e100-react-components/lib/components/Icon';
import Button from 'e100-react-components/lib/components/Button';
import { useIntl } from 'react-intl';
import { MapType } from 'common/utils/Map/constants';
import { checkIsRoadmapMapType } from 'common/utils/checkMapType';
import { useMediaQuery } from 'common/hooks';

import useStyles from './useStyles';
import ActiveItem from '../ActiveItem';
import useOnClick from './hooks/useOnClick';
import { setMapType } from '../index';

const MapButton = ({ mapType, setMapType }: Props) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const onClick = useOnClick(setMapType);
  const { isMobile } = useMediaQuery();

  return (
    <Button
      onClick={onClick}
      classes={{ root: classes.button }}
    >
      <ActiveItem
        isActive={checkIsRoadmapMapType(mapType)}
      >
        {
          isMobile ? (
            <Icon kind={'mapOutlined'} />
          ) : (
            <>{formatMessage({ id: 'map' })}</>
          )
        }
      </ActiveItem>
    </Button>
  );
};

interface Props {
  mapType: MapType;
  setMapType: setMapType;
}

export default MapButton;
